import { View, Text } from 'react-native'
import React from 'react'
import Svg, { Rect, Circle, Path } from 'react-native-svg'; // Import the necessary components


const MoneyIcon = ({ color, height, width }) => {
  return (
    <View>
      <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
        <Rect x="3" y="6" width="18" height="12" rx="2" stroke={color} />
        <Path d="M5 9H8" stroke={color} stroke-linecap="round" />
        <Path d="M16 15H19" stroke={color} stroke-linecap="round" />
        <Circle cx="12" cy="12" r="2" stroke={color} />
      </Svg>
    </View>
  )
}

export default MoneyIcon